import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { FillBatchHeader } from '../../../../models/fill_batch_header';
import { FillBatchReportService } from '../../../../services/fill-batch-report.service';
import { FillPressure } from '../../../../models/fill_pressure';

@Component({
  selector: 'app-edit-fill-batch',
  templateUrl: './edit-fill-batch.component.html',
  styleUrls: ['./edit-fill-batch.component.css']
})
export class EditFillBatchComponent implements OnInit {
  @Input() fill_Batch_Id: number;

  init: boolean;

  selectedFillPressure: FillPressure;
  pressureList: FillPressure[];
  loadedBatchDetails: FillBatchHeader;

  constructor(authService: AuthService, public router: Router, private route: ActivatedRoute, public fillBatchReportService: FillBatchReportService) {
    
  }

  ngOnInit() {
    if (this.fill_Batch_Id != undefined) {
      this.loadData();
      this.init = true;
    }
  }


  loadData() {

    this.fillBatchReportService.getHeadlineDetails(this.fill_Batch_Id).then((details) => {

      const dateStart = moment(details[0].startTime, "YYYY-MM-DD");
      const dateFinish = moment(details[0].finishTime, "YYYY-MM-DD");

      details[0].textDateStart = dateStart.format("DD MMMM YYYY");
      details[0].startTime = dateStart.format("h:mm A");

      details[0].textDateFinish = dateFinish.format("DD MMMM YYYY");
      details[0].finishTime = dateFinish.format("h:mm A");
      
      details[0].fill_Date = moment(details[0].fill_Date, "YYYY-MM-DD").toDate();
      details[0].expiry_Date = moment(details[0].expiry_Date, "YYYY-MM-DD").toDate();

      this.loadedBatchDetails = details[0];
      console.log(this.loadedBatchDetails);

      this.fillBatchReportService.getFillPressures().then((fillPressures) => {
        this.pressureList = fillPressures;
        this.selectedFillPressure = this.pressureList.filter(a => a.fill_Pressure == this.loadedBatchDetails.fill_Pressure)[0];
        console.log("TEST----------------------");
        console.log(this.selectedFillPressure);
      })
    });

  }

  saveBatch() {
    const Id = this.selectedFillPressure.fill_Pressure_ID;
    this.loadedBatchDetails.fill_Pressure_ID = parseInt(Id.toString());
    this.loadedBatchDetails.fill_Pressure = this.pressureList.filter(a => a.fill_Pressure_ID == Id)[0].fill_Pressure;

    this.fillBatchReportService.updateFillBatchDetails(this.loadedBatchDetails).then((data) => {
      console.log("Saved Batch Details");
      console.log(data);
    });
  }

}
